import React from 'react';

const CoverImageLabel = ({ text }) => {
  if (!text) {
    return null;
  }
  return <span style={labelStyle}>{` ${text} `}</span>;
};

const labelStyle = {
  verticalAlign: 'middle',
  overflow: 'visible',
  backgroundColor: 'black',
  borderRadius: '20px',
  display: 'inline',
  margin: '3px',
  padding: '.6em',
  color: 'white',
  fontSize: '11px',
  fontFamily: 'Segoe UI',
  fontWeight: '400',
};

export { CoverImageLabel };
